<template>
    <div id="multimedia-section" class="media-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}.
                <span v-if="!newTitle">
                    Vos multimédias
                </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>

        <aspect-media-suggestion></aspect-media-suggestion>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import FormComponentLoader from "../FormComponentLoader.vue"
import AspectMediaSuggestion from "../suggestion/AspectMediaSuggestion.vue"

export default {
    name: "Medias",
    components: { FormComponentLoader, AspectMediaSuggestion, },
    props: ['index', "newTitle", "helpDesc"],
    computed: {
        ...mapState('webFormStyle', ['titlesColor', 'primaryColor']),
        ...mapGetters('web_form', ['getFieldsFromTabulation']),
        tabulationFields() {
            return this.getFieldsFromTabulation('MEDIA').sort((a, b) => a.order - b.order)
        }
    }
}
</script>